<template>
	<DialogControl v-model="open" max-width="440">
		<v-card rounded="xl" class="nav-dialog">
			<v-card-title class="nav-dialog__title">
				<v-icon color="primary">{{ icon }}</v-icon>
				<span>{{ title }}</span>
			</v-card-title>
			<v-card-text>
				<p v-for="line in lines" :key="line" class="nav-dialog__text">{{ line }}</p>
				<v-text-field v-if="inputLabel" v-model="inputValue" :label="inputLabel" variant="outlined" density="comfortable" autofocus @keyup.enter="confirm" />
			</v-card-text>
			<v-card-actions>
				<v-spacer />
				<v-btn v-if="cancelText" variant="text" @click="open = false">{{ cancelText }}</v-btn>
				<v-btn color="primary" variant="flat" @click="confirm">{{ confirmText }}</v-btn>
			</v-card-actions>
		</v-card>
	</DialogControl>
</template>

<script setup>
import { ref, watch } from 'vue';
import DialogControl from '@/components/controls/DialogControl.vue';

const props = defineProps({
	title: { type: String, default: '' },
	lines: { type: Array, default: () => [] },
	icon: { type: String, default: 'info' },
	confirmText: { type: String, default: 'OK' },
	cancelText: { type: String, default: null },
	inputLabel: { type: String, default: null },
});
const emit = defineEmits(['confirm']);
const open = defineModel({ type: Boolean, default: false });
const inputValue = ref('');

watch(open, (value) => value && (inputValue.value = ''));

const confirm = () => {
	open.value = false;
	emit('confirm', props.inputLabel ? inputValue.value : undefined);
};
</script>
